import reportWithNoDataStyle from "./report-with-no-data.module.scss";
import * as React from "react";


export const ReportWithNoData : React.SFC = () =>{
        return <div className={reportWithNoDataStyle.ReportWithNoData}>
        <div className="row">
            <div className={`col-xs-12 ${reportWithNoDataStyle.logo}`}>
                <a href="http://trackmangolf.com/" target="_blank" rel="noopener noreferrer">
                    <img src="Images/unleash-potential-logo-new.png" alt="Trackman logo" />
                </a>
            </div>
        </div>
        <div className={`${reportWithNoDataStyle.infoContainer} row`}>
            <div className={`${reportWithNoDataStyle.noDataContainer} col-xs-12`}>
                <div className={reportWithNoDataStyle.noDataBox}>
                    <p>Data not available.</p>
                </div>
            </div>
        </div>
    </div>;
}
